import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominasNominaColaboradoresDescuentos', {
    template: template,
    controller: NominasNominaColaboradoresDescuentosComponent,
    bindings: {
      idProyecto: '<',
      idNomina: '<',
    },
  })

function NominasNominaColaboradoresDescuentosComponent($q, $state, NominasNominaStatus, NominasNominaColaboradoresDescuentos) {
  let $ctrl = this

  $ctrl.$onInit = $onInit
  $ctrl.actualizar = actualizar
  $ctrl.filtrar = filtrar
  $ctrl.filtro = ''
  $ctrl.grid = undefined

  function $onInit() {
    $ctrl.$promise = $q.all([
      NominasNominaStatus.get($ctrl.idProyecto, $ctrl.idNomina)
        .then(function (response) {
          $ctrl.estatus = {
            aplicado: response.data.status === 'C',
            calculado: response.data.status_calculado,
          }
        }),
      NominasNominaColaboradoresDescuentos.get($ctrl.idProyecto, $ctrl.idNomina)
        .then(function (data) {
          $ctrl.grid = data
        }),
    ])
  }

  function actualizar() {
    $state.reload()
  }

  function filtrar() {
    $ctrl.grid.api.setQuickFilter($ctrl.filtro)
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/colaboradores/descuentos/component.js